/**
 * Réponse de la RPC `start_attempt` (migration 0660) : l'identifiant de
 * l'essai, ou un refus — `ALREADY_DONE_TODAY` quand l'élève a déjà terminé cet
 * exercice en entier aujourd'hui (rouvert le lendemain). PUR, testé.
 */

export type StartAttemptResult =
  | { ok: true; attemptId: string }
  | { ok: false; error: string; availableAt: string | null };

export function parseStartAttempt(data: unknown): StartAttemptResult {
  if (typeof data === 'string' && data) return { ok: true, attemptId: data };
  const r = (data ?? {}) as { attempt_id?: unknown; error?: unknown; available_at?: unknown };
  if (typeof r.attempt_id === 'string' && r.attempt_id)
    return { ok: true, attemptId: r.attempt_id };
  return {
    ok: false,
    error: typeof r.error === 'string' ? r.error : 'UNKNOWN',
    availableAt: typeof r.available_at === 'string' ? r.available_at : null,
  };
}

export class StartAttemptError extends Error {
  constructor(
    readonly code: string,
    readonly availableAt: string | null,
  ) {
    super(code);
    this.name = 'StartAttemptError';
  }
}

/** Message affiché à la place de « Commencer ». */
export function startAttemptErrorMessage(code: string): string {
  if (code === 'ALREADY_DONE_TODAY')
    return 'Tu as déjà fait cet exercice aujourd’hui. Reviens demain pour le refaire !';
  return 'Impossible de commencer l’exercice pour le moment. Réessaie.';
}
